<template>
    <section class="section">
        <div>
            <div class="level is-mobile">
                <div class="level-left">
                    <div class="level-item">
                        <p
                            v-t="'Dashboard.groups'"
                            class="has-text-weight-bold is-size-5"
                        ></p>
                    </div>
                </div>
                <div class="level-right">
                    <div class="level-item buttons">
                        <button
                            v-if="$store.getters.isAdmin"
                            class="button"
                            @click="requestPermissions"
                        >
                            <img
                                class="image is-24x24"
                                src="https://edu.google.com/images/classroom/classroom-icon/hero_logo.png"
                            />
                            <p class="pl-2">
                                {{ $t('Classes.connect_with_google') }}
                            </p>
                        </button>
                        <button
                            v-t="'Classes.add_class'"
                            class="button is-primary"
                            @click="showModal = true"
                        />
                    </div>
                </div>
            </div>
            <div class="table-container">
                <table
                    class="table is-bordered is-fullwidth is-striped is-hoverable"
                >
                    <thead>
                        <tr>
                            <th v-t="'Classes.class_name'" />
                            <th v-t="'Classes.members_number'" />
                            <th v-t="'Classes.shortCode'" />
                            <th v-t="'Classes.id'" />
                        </tr>
                    </thead>

                    <tbody>
                        <tr
                            v-for="(group, index) in groups"
                            :key="index"
                            @click.stop="
                                localGroup = group;
                                showGroupShareModal = true;
                            "
                        >
                            <td>{{ group.name }}</td>

                            <td>
                                {{ group.members.length }}
                                <span v-t="'Classes.members_counts'"></span>
                            </td>
                            <td>
                                {{ group.shortCode }}
                            </td>
                            <td>
                                {{ group.course_id }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <user-groups-modal
            v-if="showModal"
            :active.sync="showModal"
            :group="localGroup"
            @close="localGroup = { members: [] }"
            @created="
                showGroupShareModal = true;
                localGroup = $event;
                fetchGroups();
            "
        />
        <DashboardGroupShareModal
            v-if="showGroupShareModal"
            :window-title="$t('Classes.class_name')"
            :content-title="''"
            :group="localGroup"
            @close="
                showGroupShareModal = false;
                localGroup = { members: [] };
            "
            @edit="
                showGroupShareModal = close;
                showModal = true;
            "
        ></DashboardGroupShareModal>
    </section>
</template>

<script>
import UserGroupsModal from '@/components/UserGroupsModal';
import DashboardGroupShareModal from '@/components/DashboardGroupShareModal';
import AppAvatarList from '@/components/AppAvatarList';
import { fetchItems, deleteItem, importClasses } from '@/services/API';
import { pluck } from 'underscore';
export default {
    components: {
        UserGroupsModal,
        AppAvatarList,
        DashboardGroupShareModal,
    },
    filters: {
        membersLength(members) {
            if (members) return members.length;
            else return 0;
        },
    },
    data() {
        return {
            groups: this.$store.getters.groups,
            showModal: false,
            showGroupShareModal: false,
            localGroup: undefined,
        };
    },
    mounted() {
        this.fetchGroups();
    },
    methods: {
        async requestPermissions() {
            //TODO check google user granted scopes
            //return importClasses();
            let gapi = await this.$gapi.getGapiClient();
            let auth2 = gapi.auth2.getAuthInstance();
            console.log(auth2.currentUser.get());
            await auth2.currentUser
                .get()
                .grant({
                    approval_prompt: 'auto',
                    include_granted_scopes: 'true',
                    response_type: 'code',
                    scope: 'https://www.googleapis.com/auth/classroom.courses.readonly https://www.googleapis.com/auth/classroom.courses https://www.googleapis.com/auth/classroom.profile.emails https://www.googleapis.com/auth/classroom.profile.photos https://www.googleapis.com/auth/classroom.rosters https://www.googleapis.com/auth/classroom.rosters.readonly https://www.googleapis.com/auth/classroom.coursework.students',
                })
                .then((e) => {
                    let response = auth2.currentUser.get().getAuthResponse();
                    this.$store.dispatch('login', response).then(() => {
                        importClasses();
                    });
                    /* gapi.client.classroom.courses
            .list({
              pageSize: 10
            })
            .then(function(response) {
              var courses = response.result.courses;
              courses.forEach(course => {
                console.log(course);
                let students = gapi.client.classroom.courses.students
                  .list({
                    courseId: course.id
                  })
                  .then(response => {
                    console.log(response.result.students);
                  });
              });
            });*/
                });
        },
        membersAvatars(group) {
            return pluck(group.members, 'avatar');
        },
        async fetchGroups() {
            const groupsResponse = await fetchItems('group');
            this.groups = groupsResponse.data;
        },
        async deleteGroup() {
            await deleteItem('group', this.group._id);
            this.showModal = false;
            this.fetchGroups();
        },
    },
};
</script>

<style></style>
